import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

  public isLoading = false;
  constructor(private loader: LoaderService) {
    this.loader.isLoading.subscribe((loading) => {
      this.isLoading = loading
    })
  }
}
